import { EntityConfig } from "../../../..";


export const TratamentoConfig : EntityConfig = [
    {
        id: 'id',
        label: 'Id',
        nonEditable: true,
        type: 'id',
        hidden: true
      },
    {
        id: 'observacoes',
        label: 'Observações',
        type: 'text'
    },
    {
        id: 'isExternal',
        label: 'Operação externa',
        type: 'boolean',
        filterable: true,
    },
    {
        id: 'dataExpedicao',
        label: 'Data de saída',
        type: 'date',
        conditional : (form : any)  => form?.isExternal 
    }

]